import { URLS } from 'api/constants';
import { IComment } from 'constants/types';
import { useLazyQuery } from 'hooks/useQuery';
import { useMutation } from 'hooks/useMutation';
import { apiGet, apiRequest } from 'lib/api/client';
import { PaginationResponse } from 'lib/api/types';

interface CommentsRequest {
  id?: string;
  page?: number;
  limit?: number;
}

interface CreatePublicationCommentRequest {
  publication_id: string;
  message: string;
  likes: number;
  dislikes: number;
  parent: string | null;
}

export const useLazyCommentsQuery = () =>
  useLazyQuery<PaginationResponse<IComment>, CommentsRequest>(
    ({ id, page, limit }) => {
      if (id) {
        return apiGet<PaginationResponse<IComment>>(
          `${URLS.COMMENTS_BY_PUBLICATION}${id}`
        );
      }

      return apiGet<PaginationResponse<IComment>>(
        URLS.COMMENTS_BY_PUBLICATION,
        {
          page,
          limit,
        }
      );
    }
  );

export const useCreatePublicationCommentsMutation = () =>
  useMutation<CreatePublicationCommentRequest, void>(
    ({ publication_id, message, likes, dislikes, parent }) =>
      apiRequest<void>(URLS.PUBLICATIONS, {
        method: 'POST',
        auth: true,
        body: {
          publication_id,
          message,
          likes,
          dislikes,
          parent,
        },
      })
  );
